import { render, staticRenderFns } from "./aParityGraphBg.vue?vue&type=template&id=7089b801"
import script from "./aParityGraphBg.vue?vue&type=script&lang=js"
export * from "./aParityGraphBg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports